import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { SearchIcon } from "@smartsheet/lodestar-icons";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { MagnifyingGlassIcon } from "@smartsheet/ursa-icons";
import { focusRingTheme } from "../../../util/createFocusRingStyles";
import { getInputFieldHeightValue, InputFieldBaseProps } from "../../../util/inputFieldBaseProps";
import { TextInput } from "../TextInput";
import { formInputTheme } from "./formInputTheme";

interface StyledButtonProps extends InputFieldBaseProps {
    isDisabled: boolean;
    themeMode: RequiredThemeKeys;
}
export const StyledButton = styled("button")<StyledButtonProps>`
    border-style: none;
    background-color: transparent;
    padding: 0;
    height: ${({ themeMode, inputFieldHeight }) =>
        formInputTheme.searchInputButtonSize[getInputFieldHeightValue(themeMode, inputFieldHeight)](themeMode)};
    width: ${({ themeMode, inputFieldHeight }) =>
        formInputTheme.searchInputButtonSize[getInputFieldHeightValue(themeMode, inputFieldHeight)](themeMode)};
    cursor: ${({ isDisabled }) => (isDisabled ? "default" : "pointer")};
    // To force the height to be the children's height.
    display: flex;
    justify-content: center;
    align-items: center;
    // This only applies to the clear button. The search icon takes Clickable's.
    &:focus {
        outline-color: ${({ themeMode }) => focusRingTheme.outerColor(themeMode)};
        border-radius: ${({ themeMode }) => formInputTheme.searchInputButtonRadius(themeMode)};
    }
`;

export const SearchIconStyles = css`
    // Otherwise the icon is inline-block which gives it a bit more than the specified height.
    display: block;
    cursor: text;
`;

export const StyledLodestarSearchIcon = styled(SearchIcon)(SearchIconStyles);
export const StyledUrsaSearchIcon = styled(MagnifyingGlassIcon)(SearchIconStyles);
export const StyledTextInput = styled(TextInput)`
    input::-webkit-search-cancel-button {
        display: none; // Hide the native search clear button so we can add our own styled one
    }
`;
